import React, { useEffect } from 'react';

function resolveVideo(url) {
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (yt) return { type: 'iframe', src: `https://www.youtube.com/embed/${yt[1]}` };
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return { type: 'iframe', src: `https://player.vimeo.com/video/${vm[1]}` };
  // Nextcloud public share links (/s/XXXXX) need /download appended for direct streaming
  if (/\/s\/[a-zA-Z0-9]+\/?$/.test(url)) return { type: 'video', src: url.replace(/\/?$/, '/download') };
  return { type: 'video', src: url };
}

export default function VideoOverlay({ url, onClose }) {
  const resolved = resolveVideo(url);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.92)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      {/* Close button */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute', top: 16, right: 20,
          background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 6, color: '#ccc', fontSize: 22, lineHeight: 1,
          width: 44, height: 44, cursor: 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontFamily: 'monospace',
        }}
        aria-label="Close"
      >
        ×
      </button>

      {/* Video container — stop click propagation so clicking video doesn't close */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: '90vw', maxWidth: 1100,
          maxHeight: '85vh',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        {resolved.type === 'iframe' ? (
          /* Responsive iframe wrapper maintaining 16:9 */
          <div style={{ width: '100%', position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              src={resolved.src}
              title="Pre-race video"
              sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute', inset: 0,
                width: '100%', height: '100%',
                border: 'none', borderRadius: 6,
              }}
            />
          </div>
        ) : (
          <video
            src={resolved.src}
            controls
            style={{
              width: '100%', maxHeight: '85vh',
              borderRadius: 6, outline: 'none',
              background: '#000',
            }}
          />
        )}
      </div>

      <p style={{
        position: 'absolute', bottom: 14,
        fontFamily: 'monospace', fontSize: 11, color: '#333',
        letterSpacing: '0.08em',
      }}>
        ESC TO CLOSE
      </p>
    </div>
  );
}
